package br.com.texeratx.boardgametimeapp.ui.screens.stats

import br.com.texeratx.boardgametimeapp.data.repository.StatsRepository
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class StatsViewModel(
    private val statsRepository: StatsRepository,
) : ScreenModel {

    private val _state = MutableStateFlow(StatsUiState())
    val state = _state.asStateFlow()

    fun selectTab(tab: StatsTab) {
        _state.value = _state.value.copy(selectedTab = tab, error = null)
    }

    fun setYear(year: Int) {
        _state.value = _state.value.copy(selectedYear = year, error = null)
        // opcional: auto-carregar ao trocar o ano se estiver na aba Year
        if (_state.value.selectedTab == StatsTab.Year) {
            loadYear(year)
        }
    }

    fun loadGlobal() {
        screenModelScope.launch {
            _state.value = _state.value.copy(isLoading = true, error = null)

            val result = statsRepository.getGlobalStats()
            result.fold(
                onSuccess = { dto ->
                    _state.value = _state.value.copy(
                        isLoading = false,
                        global = dto,
                        error = null
                    )
                },
                onFailure = { e ->
                    _state.value = _state.value.copy(
                        isLoading = false,
                        error = e.message ?: "Erro ao carregar estatísticas"
                    )
                }
            )
        }
    }

    fun loadYear(year: Int) {
        screenModelScope.launch {
            _state.value = _state.value.copy(isLoading = true, error = null)

            val result = statsRepository.getYearHistory(year)
            result.fold(
                onSuccess = { dto ->
                    _state.value = _state.value.copy(
                        isLoading = false,
                        yearHistory = dto,
                        error = null
                    )
                },
                onFailure = { e ->
                    _state.value = _state.value.copy(
                        isLoading = false,
                        error = e.message ?: "Erro ao carregar histórico do ano"
                    )
                }
            )
        }
    }

    fun loadDuration() {
        screenModelScope.launch {
            _state.value = _state.value.copy(isLoading = true, error = null)

            val result = statsRepository.getDurationStats()
            result.fold(
                onSuccess = { list ->
                    _state.value = _state.value.copy(
                        isLoading = false,
                        durationStats = list,
                        error = null
                    )
                },
                onFailure = { e ->
                    _state.value = _state.value.copy(
                        isLoading = false,
                        error = e.message ?: "Erro ao carregar duração por jogo"
                    )
                }
            )
        }
    }
}

